module.exports = "/src/views/donate/main/assets/images/menu/cases.png";